import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </Link>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 md:p-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
            Terms of Service
          </h1>

          <div className="prose dark:prose-invert">
            <h2>1. Introduction</h2>
            <p>
              Welcome to the Algorand Agentic Platform by GoPlausible. By accessing or using our service, you agree to be bound by these terms.
            </p>

            <h2>2. Service Description</h2>
            <p>
              The Algorand Agency is an Algorand powered AI Agentic Platform. The service requires a GoPlausible profile and an Algorand wallet for authentication.
            </p>

            <h2>3. User Responsibilities</h2>
            <ul>
              <li>Maintain the security of your wallet and credentials</li>
              <li>Use the service in compliance with applicable laws</li>
              <li>Not attempt to circumvent any service limitations or restrictions</li>
            </ul>

            <h2>4. AI Interaction Guidelines</h2>
            <p>
              While our AI assistant strives to provide accurate information, users should:
            </p>
            <ul>
              <li>Verify critical information independently</li>
              <li>Not rely solely on AI-generated code without testing</li>
              <li>Be aware that responses may not always be perfect</li>
            </ul>

            <h2>5. Intellectual Property</h2>
            <p>
              Users retain rights to their input content. AI-generated responses are provided for user benefit but may not be guaranteed unique or original.
            </p>

            <h2>6. Service Availability</h2>
            <p>
              We strive to maintain high availability but do not guarantee uninterrupted service. Maintenance or updates may occasionally affect availability.
            </p>

            <h2>7. Limitation of Liability</h2>
            <p>
              The service is provided "as is" without warranties. We are not liable for any damages arising from service use or AI-generated content.
            </p>

            <h2>8. Changes to Terms</h2>
            <p>
              We may update these terms at any time. Continued use of the service constitutes acceptance of any changes.
            </p>

            <h2>9. Contact</h2>
            <p>
              For questions about these terms, please contact us through our website at{' '}
              <a 
                href="https://goplausible.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 hover:underline"
              >
                goplausible.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};